module.exports = __webpack_public_path__ + "static/scale-model-of-blount-mansion-in-knoxville-tennessee-3d6fdc1d501b8053af4bafb03f583f99.png";